import { BaseDto } from '../base.dto'
import { PagingDto } from '../paging.dto'
import { TranslationDto } from '../translation.dto'

export class FloorDto extends BaseDto {
  nameEn?: string
  nameKh?: string
  mallId?: string
  sortOrder?: number
  enabled?: boolean

  static create({ id, nameEn, nameKh, mallId, sortOrder, enabled }: FloorDto) {
    return Object.assign(new FloorDto(), {
      id: id || null,
      nameEn: nameEn || '',
      nameKh: nameKh || '',
      mallId: mallId || null,
      sortOrder: sortOrder || 0,
      enabled: enabled || true
    })
  }
}

export class CreateFloorDto {
  nameEn: string
  nameKh: string
  mallId: string
  sortOrder: number
  enabled: boolean
}

export class UpdateFloorDto {
  nameEn?: string
  nameKh?: string
  mallId?: string
  sortOrder?: number
  enabled?: boolean
}

export class FindFloorDto extends PagingDto {
  mallId?: string
  enabled?: string
  searchText?: string
} 